import { LandingPage } from "@/components/landing/LandingPage";
import { renoLandingConfig } from "@/data/landingConfigs";

/**
 * Meta-ads landing page for home-reno / DIY
 * (/reno-recus-retours, /en/home-reno-receipts-returns).
 */
const RenoLanding = () => <LandingPage config={renoLandingConfig} />;

export default RenoLanding;
